export default __webpack_public_path__ + "static/media/SchedulerOverview.96408dca.png";